document.addEventListener('DOMContentLoaded', () => {
  // Função para calcular data de entrega
  function calculateDeliveryDate(days) {
    const today = new Date();
    let deliveryDate = new Date(today);
    let businessDays = 0;
    
    while (businessDays < days) {
      deliveryDate.setDate(deliveryDate.getDate() + 1);
      // Pular finais de semana (0 = domingo, 6 = sábado)
      if (deliveryDate.getDay() !== 0 && deliveryDate.getDay() !== 6) {
        businessDays++;
      }
    }
    
    // Formatar data para exibição simples (23/09)
    const day = deliveryDate.getDate().toString().padStart(2, '0');
    const month = (deliveryDate.getMonth() + 1).toString().padStart(2, '0');
    
    return `${day}/${month}`;
  }

  async function applyCepMask(cep) {
    cep = cep.replace(/\D/g, "");
    cep = cep.replace(/^(\d{5})(\d{3})$/, "$1-$2");
    return cep;
  }

  async function fetchProvince(cep) {
    try {
      const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
      const data = await response.json();
      if (data.erro) {
        throw new Error('CEP inválido');
      }
      return data.uf;
    } catch (error) {
      document.getElementById('shipping-result').innerHTML = 'CEP inválido. Tente novamente.';
      throw error;
    }
  }

  async function getCorreiosToken() {
    try {
      const response = await fetch('https://cws.correios.com.br/v1/autentica/cartaopostagem', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          numero: "22481273000138",
          contrato: "JTIp7SXRsbkyt6Yy9m7GFDSfciinZhv5yUcfSdxw",
          dr: 0
        })
      });
      
      const data = await response.json();
      if (response.status === 201) {
        return data.token;
      } else {
        throw new Error('Falha na autenticação com os Correios');
      }
    } catch (error) {
      throw error;
    }
  }

  async function calculateCorreiosShipping(cep, token) {
    try {
    
      const response = await fetch('https://cws.correios.com.br/v1/preco/prazo', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
                  cepOrigem: "00000000",
        cepDestino: cep,
        peso: 1,
        comprimento: 20,
        altura: 10,
        largura: 15,
        servicos: ["04014", "04510"]
        })
      });
      
      const data = await response.json();
      return data;
    } catch (error) {
      throw error;
    }
  }

  async function saveCartState() {
    const response = await fetch('/cart.js');
    return response.json();
  }

  async function restoreCartState(cartState) {
    const updates = {};
    cartState.items.forEach(item => {
      updates[item.variant_id] = item.quantity; 
    });

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ updates })
    });
  }

  async function clearCart() {
    await fetch('/cart/clear.js', { method: 'POST' });
  }

  const postalCodeInput = document.getElementById('postal-code');
  postalCodeInput.addEventListener('input', function() {
    this.value = this.value.replace(/\D/g, '');
  });

  postalCodeInput.addEventListener('change', function() {
    this.value = this.value.replace(/\D/g, '');
    if (this.value.length === 8) {
      this.value = this.value.replace(/^(\d{5})(\d{3})$/, "$1-$2");
    }
  });


  const shippingCalc = document.getElementById('shipping-calc');
  const productForm = document.querySelector('form.product-form');

  if (productForm) {
    productForm.addEventListener('change', function(event) {
      if (event.target.matches('input[type="radio"]')) {
        const variantIdElement = document.querySelector('##variant-id') || document.querySelector('form.product-form input[name="id"]');
        const variantId = variantIdElement ? variantIdElement.value : null;
        if (variantId) {
          shippingCalc.dataset.variantId = variantId;
        }
      }
    });
  }

  document.getElementById('calculate-shipping').addEventListener('click', async function() {
    const button = this;
    const postalCode = postalCodeInput.value.replace(/\D/g, '');
    const shippingCalc = document.getElementById('shipping-calc');
    const variantIdElement = document.querySelector('#variant-id') || document.querySelector('form.product-form input[name="id"]');
    const productVariantId = variantIdElement ? variantIdElement.value : shippingCalc.dataset.variantId;
    const quantityInput = document.querySelector('form.product-form input[name="quantity"]');
    const productQuantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;

    if (!productVariantId) {
      return;
    }


    button.classList.add('loading');
    button.disabled = true;

    if (postalCode.length !== 8) {
      document.getElementById('shipping-result').innerHTML = 'Por favor, insira um CEP válido.';
      button.classList.remove('loading');
      button.disabled = false;
      return;
    }

    try {
      const cartState = await saveCartState();
      await clearCart();
      const province = await fetchProvince(postalCode);
      
      if (!province) {
        throw new Error('Não foi possível identificar o estado do CEP informado');
      }

      
      
      const addToCartResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: productVariantId,
          quantity: productQuantity
        })
      });
      
          const addToCartData = await addToCartResponse.json();
      
        async function fetchShippingRatesWithRetry(startTime = Date.now(), attempt = 1) {
    const maxTime = 15000;
    const currentTime = Date.now();
    const elapsedTime = currentTime - startTime;
            if (elapsedTime >= maxTime) {
      return { rates: [], data: { shipping_rates: [] } };
    }
        
        const timestamp = Date.now();
        const randomHash = Math.random().toString(36).substring(7);
        const shippingUrl = `/cart/shipping_rates.json?shipping_address[zip]=${postalCode}&shipping_address[country]=BR&shipping_address[province]=${province}&_t=${timestamp}&_h=${randomHash}`;
        
        
        
        const response = await fetch(shippingUrl);
        const data = await response.json();
        const rates = data.shipping_rates;
        
    
        const hasNoRates = !rates || rates.length === 0;
        const hasOnlyLocalDelivery = rates && rates.length === 1 && rates[0]?.name === 'Local Delivery';
        const shouldRetry = hasNoRates || hasOnlyLocalDelivery;
        
        if (shouldRetry) {
          const waitTime = Math.min(500 + (attempt * 200), 2000);
          await new Promise(resolve => setTimeout(resolve, waitTime));
          return fetchShippingRatesWithRetry(startTime, attempt + 1);
        }
        
            return { rates, data };
      }
      
      const { rates, data } = await fetchShippingRatesWithRetry();
      
      
      
      if (!rates || rates.length === 0) {
        document.getElementById('shipping-result').innerHTML = 'Erro ao calcular frete. Tente novamente.';
        document.getElementById('shipping-result').classList.add('active');
        await restoreCartState(cartState);
        button.classList.remove('loading');
        button.disabled = false;
        return;
      }
      
      let resultHtml = '<ul>';
      
      
      rates.forEach((rate, index) => {
        const deliveryText = rate.description || '';
        const priceValue = parseFloat(rate.price);
        const priceText = (priceValue === 0) ? 'Grátis' : `R$ ${priceValue.toFixed(2).replace('.', ',')}`;

        // Formatar nome do método de entrega
        let displayName = rate.name === 'Local Delivery' ? 'Entrega Motoboy' : rate.name;
        
        // Adicionar "Correios" na frente se for PAC ou SEDEX
        if (displayName.toUpperCase().includes('PAC') || displayName.toUpperCase().includes('SEDEX')) {
          displayName = `Correios ${displayName}`;
        }

        // Calcular data de entrega
        let deliveryDate = '';
        
        if (displayName === 'Entrega Motoboy') {
          deliveryDate = calculateDeliveryDate(1);
        } else if (rate.delivery_days && rate.delivery_days[0]) {
          const days = rate.delivery_days[0];
          deliveryDate = calculateDeliveryDate(days);
        }

        resultHtml += `
          <li class="shipping-list-item">
            <div class="method">
              ${displayName} <span class="price" style="color: #51a559;">${priceText}</span>
            </div>
            ${deliveryDate ? `<div class="delivery-date">${deliveryDate}</div>` : ''}
          </li>`;
      });
      
      resultHtml += '</ul>';
  
      document.getElementById('shipping-result').innerHTML = resultHtml;
      document.getElementById('shipping-result').classList.add('active');

      await restoreCartState(cartState);
      button.classList.remove('loading');
      button.disabled = false;
    } catch (error) {
      document.getElementById('shipping-result').innerHTML = 'Erro ao calcular frete. Tente novamente.';
      // Error

      const cartState = await saveCartState();
      await restoreCartState(cartState);
      button.classList.remove('loading');
      button.disabled = false;
    }
  });
});
